import { jsxs as s, jsx as o } from "react/jsx-runtime";
import { Image as i } from "../Image/index.js";
import { TagContainer as p, ImageWrapper as c, TagIcon as g } from "./style.js";
import { Xmark as I, Plus as f } from "@pelando/fontawesome/icons";
function T({
  children: e,
  active: r,
  onClick: n,
  imageUrl: a,
  onKeyDown: m,
  className: t
}) {
  return /* @__PURE__ */ s(
    p,
    {
      role: "option",
      "aria-selected": !!r,
      tabIndex: 0,
      onClick: n,
      onKeyDown: m,
      className: t,
      children: [
        !!a && /* @__PURE__ */ o(c, { children: /* @__PURE__ */ o(i, { src: a }) }),
        e,
        /* @__PURE__ */ o(g, { icon: r ? I : f })
      ]
    }
  );
}
export {
  T as Tag
};
